import { useCallback, useState } from 'react'
import { useMounted } from '../../../Hooks/useMounted'
import { useAppDispatch } from '../../../Hooks/useAppDispatch'
import { ConsigneesActions } from '../StoreAdapter'
import { ConsigneeSchema } from '../../../Schema/ConsigneeSchema'
import { ServiceLocator } from '../../../Services/ServiceLocator'
import { ConsigneesAPI } from '../../../Services/API/ConsigneesAPI'

export const useDeleteConsignee = () => {
  const dispatch = useAppDispatch()
  const mounted = useMounted()

  const [processing, setProcessing] = useState(false)
  const [error, setError] = useState(false)
  const [errorMessage, setErrorMessage] = useState<string>(null)

  const deleteConsignee = useCallback(
    async (schemaId: string): Promise<ConsigneeSchema> => {
      setProcessing(true)
      return ServiceLocator.resolve(ConsigneesAPI)
        .deleteEntity(schemaId)
        .then((schema) => {
          dispatch(ConsigneesActions.removeOne(schemaId))
          if (mounted.current) {
            setProcessing(false)
            setError(true)
            setErrorMessage(null)
          }
          return schema
        })
        .catch((err) => {
          if (mounted.current) {
            setProcessing(false)
            setError(true)
            setErrorMessage(err?.response?.data?.errorMessage)
            throw err
          }
          return null
        })
    },
    [dispatch, mounted],
  )

  return {
    processing,
    error,
    errorMessage,
    deleteConsignee,
  }
}
